/**
 * Netlify Image CDN URL builder.
 *
 * In production, transforms images via /.netlify/images so they're resized,
 * format-converted, and edge-cached. In dev (npm start), returns the original
 * URL so we don't depend on Netlify being available locally.
 */
const IS_PROD = process.env.NODE_ENV === "production";

/**
 * @param {string} src   - Source image path (relative like "/pitch-deck/1.png")
 *                         or an absolute URL (must be in netlify.toml remote_images).
 * @param {object} opts
 * @param {number} [opts.w]  - Target width in px.
 * @param {number} [opts.h]  - Target height in px.
 * @param {"contain"|"cover"|"fill"} [opts.fit]
 * @param {"avif"|"webp"|"jpg"|"png"} [opts.fm="webp"]
 * @param {number} [opts.q=80]
 */
export function img(src, { w, h, fit, fm = "webp", q = 80 } = {}) {
  if (!src) return src;
  if (!IS_PROD) return src;
  const params = new URLSearchParams({ url: src });
  if (w) params.set("w", String(w));
  if (h) params.set("h", String(h));
  if (fit) params.set("fit", fit);
  if (fm) params.set("fm", fm);
  if (q) params.set("q", String(q));
  return `/.netlify/images?${params.toString()}`;
}
